// Demo project sites. Rename these to real project sites when onboarding a client.
// Each site is where field workers report to and where WhatsApp templates originate.

import { BRAND } from "@/brand";

const DEFAULT_MOBILE = "+91 90000 00000";

const buildSite = (label, address) => ({
  branch: `${label} – ${BRAND.companyName}`,
  address,
  mobile: DEFAULT_MOBILE,
  mapLink: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(label)}`,
});

export const BRANCHES = {
  "Site A – Downtown": buildSite(
    "Site A – Downtown",
    `${BRAND.companyName}
Downtown Project Site
Sector 1, Main Road`,
  ),
  "Site B – Riverside": buildSite(
    "Site B – Riverside",
    `${BRAND.companyName}
Riverside Project Site
Sector 2, Riverbank Road`,
  ),
  "Site C – Highway Zone": buildSite(
    "Site C – Highway Zone",
    `${BRAND.companyName}
Highway Project Site
Sector 3, NH Extension`,
  ),
  "Site D – Industrial Park": buildSite(
    "Site D – Industrial Park",
    `${BRAND.companyName}
Industrial Project Site
Sector 4, Warehouse Zone`,
  ),
};

export const LOCATION_KEYS = Object.keys(BRANCHES);

const HQ = BRANCHES[LOCATION_KEYS[0]];

export const COMMON = {
  urgentMobile: DEFAULT_MOBILE,
};

export const getBranch = (location) => BRANCHES[location] || HQ;
